import React, { ReactNode } from 'react';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import { MEMBERPAGES_URL } from '@lib/constants';
import useSelector from '@redux/typedHooks';
import { updateUrlQueryValues } from '../utils/updateUrlQueryValues';
import useEspial from '../hooks/Espial/useEspial';
import { useGTMTrackAuthState } from '../hooks/GTM/useGTMTrackAuthState';
import { SessionTransfer } from '../hooks/SessionTransfer/SessionTransfer';

interface Props {
  children: ReactNode | ReactNode[];
}

const Auth0ProviderWithHistory = ({ children }: Props) => {
  const auth0Domain = useSelector((state) => state.application.authDomain);
  const auth0ClientId = useSelector((state) => state.application.authClientId);
  const auth0RedirectUri = useSelector((state) => state.application.authRedirectUri);
  const auth0Audience = useSelector((state) => state.application.authAudience);

  const { trackLogin, trackLogout } = useEspial();
  const { trackLogin: trackLoginGA, trackLogout: trackLogoutGA } = useGTMTrackAuthState();

  const onRedirectCallback = (appState?: AppState) => {
    if (appState?.returnTo) {
      updateUrlQueryValues.updateRedirect(appState?.returnTo);

      if (appState?.returnTo === `/${MEMBERPAGES_URL}`) {
        trackLogin();
        trackLoginGA();
      } else if (appState?.returnTo.includes('nafid/logout')) {
        trackLogout();
        trackLogoutGA();
      }
    }
  };

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        scope: `openid profile name email https://id.naf.no/external-ids/required/customerId`,
        redirect_uri: auth0RedirectUri,
        audience: auth0Audience,
      }}
      cookieDomain="naf.no"
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
    >
      <SessionTransfer />
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
